module.exports = __webpack_public_path__ + "media/images/stage3-bfb12236.png";